<template>
  <div class="tool-bar">
    {{ CheckOrderPermission }}
    {{ CheckPaymentMessagePermission }}
    <AttachFile ref="attachFile"></AttachFile>
    <AttachFileV2 ref="attachFileV2"></AttachFileV2>
    <Upload ref="upload"></Upload>
    <SaleBusinessCard ref="saleBusinessCard"></SaleBusinessCard>
    <QuicklyJoinFriendGroup
      ref="quicklyJoinFriendGroup"
      :roomInfo="roomInfo"
      :staffInfo="staffInfo"
    ></QuicklyJoinFriendGroup>
    <el-dialog class="popup" :visible.sync="visible" height="100%" top="0">
      <SocialLeadPairedBasisInfo
        :socialLeadId="roomInfo.SocialLeadId"
        :staffID="staffInfo.StaffID"
        :tutorChatToken="$route.query.tct"
      ></SocialLeadPairedBasisInfo>
    </el-dialog>
    <PaymentMessage
      v-if="!isCn"
      ref="paymentMessage"
      :roomInfo="roomInfo"
      :staffInfo="staffInfo"
    ></PaymentMessage>

    <swiper :options="swiperOption">
      <swiper-slide v-if="SpeakPermission">
        <div class="tool-bar-icon">
          <div>
            <a href="javascript:void(0)" @click="showSticker()">
              <img src="../../../static/img/smile.svg" title="貼圖" />
            </a>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide v-if="SpeakPermission">
        <div class="tool-bar-icon">
          <el-tooltip
            content="取之不盡"
            effect="light"
            placement="top"
          ></el-tooltip>
          <a href="javascript:void(0)" @click="tiggerAttachFile">
            <img
              src="../../../static/img/icon-attachment.png"
              title="取之不盡"
            />
          </a>
        </div>
      </swiper-slide>
      <swiper-slide v-if="SpeakPermission">
        <div class="tool-bar-icon">
          <el-tooltip
            content="檔案上傳"
            effect="light"
            placement="top"
          ></el-tooltip>
          <a href="javascript:void(0)" @click="tiggerUpload">
            <img src="../../../static/img/icon-files.png" title="檔案上傳" />
          </a>
        </div>
      </swiper-slide>
      <swiper-slide v-show="OrderPermission">
        <div class="tool-bar-icon">
          <el-tooltip
            class="item"
            effect="light"
            content="直購"
            placement="top"
          ></el-tooltip>
          <a href="javascript:void(0);" @click="openProdbuy">
            <img src="../../../static/img/icon-contractInfo.png" title="直購" />
          </a>
        </div>
      </swiper-slide>
      <swiper-slide
        v-if="!isCn"
        v-show="OrderPermission || PaymentMessagePermission"
      >
        <div class="tool-bar-icon">
          <el-tooltip
            content="付款訊息"
            effect="light"
            placement="top"
          ></el-tooltip>
          <a href="javascript:void(0)" @click="tiggerPaymentMessage">
            <img src="../../../static/img/icon-wallet.png" title="付款訊息" />
          </a>
        </div>
      </swiper-slide>
      <swiper-slide v-if="SpeakPermission">
        <div class="tool-bar-icon">
          <el-tooltip
            content="個人名片"
            effect="light"
            placement="top"
          ></el-tooltip>
          <a href="javascript:void(0)" @click="tiggerSaleBusinessCard">
            <img
              src="../../../static/img/icon-sendNameCard.png"
              title="個人名片"
            />
          </a>
        </div>
      </swiper-slide>
      <swiper-slide v-if="SpeakPermission && !ismobile">
        <div class="tool-bar-icon">
          <el-tooltip
            effect="light"
            content="快速加入好友群組"
            placement="top"
          ></el-tooltip>
          <a
            href="javascript:void(0);"
            v-on:click="tiggerQuicklyJoinFriendGroup"
          >
            <img
              src="../../../static/img/baseline_group_add_red_18dp.png"
              title="快速加入好友群組"
            />
          </a>
        </div>
      </swiper-slide>
      <swiper-slide v-if="ismobile">
        <div class="tool-bar-icon">
          <div>
            <a href="javascript:void(0)" @click="visible = true">
              <img
                src="../../../static/img/icon-personalProfile.png"
                title="客戶畫像"
              />
            </a>
          </div>
        </div>
      </swiper-slide>
      <!-- <swiper-slide>
        <div class="tool-bar-icon">
          <el-tooltip
            content="銷售素材"
            effect="light"
            placement="top"
          ></el-tooltip>
          <a href="javascript:void(0)" @click="tiggerAttachFileV2">
            <img
              src="../../../static/img/icon-attachment.png"
              title="銷售素材"
            />
          </a>
        </div>
      </swiper-slide> -->
      <swiper-slide>
        <div class="tool-bar-icon">
          <a>
            <img
              src="../../../static/img/space.png"
              title
              style="height: 35px"
            />
          </a>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { StickerHandler } from "@/handler/StickerHandler.js";
import store_sticker from "@/vuex/store_sticker.js";
import AttachFile from "../../components/Main/ChatToolBar_AttachFile.vue";
import AttachFileV2 from "../../components/Main/ChatToolBar_AttachFileV2.vue";
import Upload from "../../components/Main/ChatToolBar_Upload.vue";
import SaleBusinessCard from "../../components/Main/ChatToolBar_SaleBusinessCard.vue";
import SocialLeadPairedBasisInfo from "../../components/Main/SocialLeadPairedBasisInfo.vue";
import QuicklyJoinFriendGroup from "../../components/Main/ChatToolBar_QuicklyJoinFriendGroup.vue";
import PaymentMessage from "./ChatToolBar_PaymentMessage.vue";
import { isMobile } from "mobile-device-detect";
import Global from "@/components/Global";
import store from "@/vuex/store_chat.js";
import http from "../../http.js";
import qs from "qs";
import { SocialPairedBasisInfoHandler } from "../../handler/SocialPairedBasisInfoHandler.js";
import { WEB_TYPE, webType } from "@/constants/webType";

// 聊天室功能列
export default {
  name: "ChatToolBar",
  props: ["roomInfo", "staffInfo"],
  components: {
    AttachFile,
    AttachFileV2,
    Upload,
    SaleBusinessCard,
    SocialLeadPairedBasisInfo,
    QuicklyJoinFriendGroup,
    PaymentMessage,
  },
  created() {
    this.ismobile = isMobile;
    if (!this.ismobile) {
      this.swiperOption.slidesPerView = 17;
    }
  },
  data() {
    return {
      visible: false,
      ismobile: false,
      current_staffid: "",
      swiperOption: {
        slidesPerView: 8,
        spaceBetween: 30,
        direction: "horizontal",
      },
      OrderPermission: false,
      PaymentMessagePermission: false,
    };
  },
  methods: {
    showSticker: function () {
      if (store_sticker.state.stickerPackages.length == 0) {
        var stickerPackages = StickerHandler.getStickerPackage(
          this.roomInfo.RoomId,
          this.staffInfo.StaffID
        );
        store_sticker.dispatch("setStickerPackages", stickerPackages);
      }

      store_sticker.dispatch(
        "showStickerPackages",
        !store_sticker.state.stickerPackagesVisible
      );
    },
    tiggerAttachFile: function () {
      this.$refs.attachFile.iniData([]);
    },
    tiggerAttachFileV2: function () {
      this.$refs.attachFileV2.iniData([]);
    },
    tiggerPaymentMessage: function () {
      this.$refs.paymentMessage.iniData([]);
    },
    tiggerUpload: function () {
      this.$refs.upload.inidata();
    },
    openProdbuy: function () {
      if (this.staffInfo.StaffID == null) {
        alert("尚未載入完成，請稍後再試");
        return;
      }
      window.open(
        this.$conf.MessageAPI +
          "/Contract/openProdbuy?socialLeadId=" +
          this.roomInfo.SocialLeadId +
          "&staffId=" +
          this.staffInfo.StaffID
      );
    },
    tiggerSaleBusinessCard: function () {
      this.$refs.saleBusinessCard.inidata();
    },
    tiggerQuicklyJoinFriendGroup: function () {
      this.$refs.quicklyJoinFriendGroup.openFriendGroupList();
    },
    async GetSocialLeadModel(staffId, socialLeadId) {
      return await http
        .post(
          "SocialLeadPairedBasisInfo/GetSocialLead",
          qs.stringify({
            socialLeadId,
            staffId,
          })
        )
        .then(function (response) {
          var data = response.data;
          return data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  computed: {
    CheckOrderPermission() {
      if (this.roomInfo.SocialLeadId == undefined) return;

      //取得SocialleadModel
      let data = this.GetSocialLeadModel(
        Global.current_staffid,
        this.roomInfo.SocialLeadId
      );

      var that = this;
      data.then(function (socialLeadModel) {
        if (
          ((socialLeadModel.MainContactName != null &&
          socialLeadModel.MainContactName == that.staffInfo.StaffName) ||
          (socialLeadModel.SaMainContactName != null &&
          socialLeadModel.SaMainContactName == that.staffInfo.StaffName)) &&
          socialLeadModel.BindLeadSn != null
        ) {
          that.OrderPermission = true;
        }
      });
    },
    SpeakPermission() {
      var flag = store.state.reload;
      var speaker = store.state.speaker;
      return speaker.indexOf(Global.current_staffid) >= 0;
    },
    // CN 已改由訂單系統統一顯示付款 QRcode，SCRM 不再提供付款訊息功能
    isCn() {
      return webType === WEB_TYPE.TUTORABC_CN;
    },
    CheckPaymentMessagePermission() {
      if (this.isCn) return;
      if (this.roomInfo.SocialLeadId == undefined) return;

      //取得SocialleadModel
      let resp = SocialPairedBasisInfoHandler.HasPermission(
        Global.current_staffid,
        "SCRM_PaymentMessage"
      );

      var that = this;
      if (resp) {
        that.PaymentMessagePermission = true;
      }
    },
  },
};
</script>
<style scoped>
.tool-bar-icon {
  display: inline-block;
}
.tool-bar-icon a {
  width: 40px;
}
.tool-bar-icon .breadcrumbAttachFile a {
  width: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/ChatToolBar.vue